import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Switch,
  FormControlLabel,
  Paper,
  Grid,
} from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { authenticationService } from "src/services";
import { get, put } from "src/services/httpClient.service";
import axios from "axios";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

const EditRole = () => {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { id } = useParams(); // get roleId from URL
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();

  const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

  const [name, setName] = useState("");
  const [description, setDescription] = useState(""); // ✅ Added description state
  const [status, setStatus] = useState(true);
  const [distributorAccess, setDistributorAccess] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch role data by ID (unchanged)
  const fetchRoleById = async () => {
    try {
      setLoading(true);
      const res = await get(
        `${API_BASE_URL}/api/globalRole/vendor/${vendorId}/franchise/${franchiseId}/findById?roleId=${id}`
      );

      console.log("res", res);
      if (res?.statusCode == "200") {
        const role = res.data;
        setName(role.name || "");
        setDescription(role.description || ""); // ✅ Added to prefill description
        setStatus(role.isActive ?? true);
        setDistributorAccess(role.hasDistributorAccess ?? false);
        console.log("✅ Role fetched:", role);
      }
    } catch (error) {
      showSnackbar("❌ Error fetching role:", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoleById();
  }, [id]);

  // ✅ Handle Save (PUT API)
  const handleSave = async () => {
    const payload = {
      id: id,
      name: name,
      description: description,
      isActive: status,
      hasDistributorAccess: distributorAccess,
      vendorId: vendorId,
      franchiseId: franchiseId
    };

    console.log("📦 Update Payload:", payload);
    setLoading(true);

    try {
      const res = await put(`${API_BASE_URL}/api/globalRole`, payload);
      console.log("✅ Role updated:", res.data);
      showSnackbar("Role updated successfully!", "success");
      navigate("/Role/role");
    } catch (error) {
      console.error("❌ Error updating role:", error);
      showSnackbar("Failed to update role", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/Role/role");
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        maxWidth: "80%",
        margin: "30px auto",
        borderRadius: 2,
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, background: "#4285F4", color: "#fff", p: 1, borderRadius: 1 }}
      >
        ✏️ Edit Role
      </Typography>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={distributorAccess}
                onChange={(e) => setDistributorAccess(e.target.checked)}
                color="success"
              />
            }
            label={`Has Distributor Access : ${distributorAccess ? "ON" : "OFF"}`}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={status}
                onChange={(e) => setStatus(e.target.checked)}
                color="success"
              />
            }
            //label={status ? "ON" : "OFF"}
            label={`Status : ${status ? "ACTIVE" : "INACTIVE"}`}
          />
        </Grid>

        {/* ✅ Added Description Field */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Description"
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Grid>
      </Grid>

      <Box mt={3} display="flex" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={loading}
          sx={{ textTransform: "none" }}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleCancel}
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
      </Box>
    </Paper>
  );
};

export default EditRole;
